import React, { useEffect, useState } from 'react';
import {
  Backdrop,
  Box,
  Fade,
  Grid,
  IconButton,
  ListSubheader,
  MenuItem,
  Modal,
  Popover,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import { Formik } from 'formik';
import {
  AddCommiteMember,
  BreadcrumbsWrapper,
  DarkBlueButton,
  LightBlueButton,
  LightGrayButton,
  TextFieldWrapper,
} from '../../components';
import { validationSchema } from '../../constants/validationSchema';
import * as yup from 'yup';
import { Delete, KeyboardArrowDown } from '@mui/icons-material';
import { procurementCodeArray, timeZoneArray } from '../../constants/constants';
import { ApiManager } from '../../services/api';
import { useNavigate, useParams } from 'react-router-dom';
import useNotification from '../../hooks/useNotification';
import useScreen from '../../hooks/useScreen';
import PlacesAutofcompleteWrapper from '../../components/PlacesAutofcompleteWrapper';
import { toAbsolutePath } from '../../constants/shared-methods';
import { routesName } from '../../constants/routes-name';
import moment from 'moment';
import { UNSPSCodes } from '../../constants/UNSPSCodes';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';

function Component() {
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isAddingUser, setIsAddingUser] = useState(false);
  const { successNonification, errorNonification } = useNotification();
  const { width } = useScreen();
  const [oldFiles, setOldFiles] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [committeeMembers, setCommitteeMembers] = useState([]);
  const [tenderData, setTenderData] = useState({
    tenderTitle: '',
    refNo: '',
    publicationDate: '',
    publicationTime: '',
    publicationTimeZone: '',
    submissionDate: '',
    submissionTime: '',
    submissionTimeZone: '',
    beneficiatyLocation: '',
    lng: '',
    lat: '',
    procurementCode: '',
    procedureType: '',
    unspsCode: '',
    introduction: '',
    files: [],
    submissionInstructions:
      'Please allow some time for sending of your response. We recommend submission in good time before the deadline. Evaluate the risk of potential interference (Internet connection speed, Internet connection failure, power failure, change of computerized workplace settings, etc.).',
    deadlineForQueries: '',
    userKey1: '',
    userKey2: '',
    userKey3: '',
  });
  //////////////

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openUNSPSPopup = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const closeUNSPSPopup = () => {
    setAnchorEl(null);
  };
  const isOpenUNSPSPopup = Boolean(anchorEl);
  const id = isOpenUNSPSPopup ? 'unsps-popover' : undefined;

  ///////////

  const toggleAddUser = () => setIsAddingUser((check) => !check);

  const getTenderById = async () => {
    const res = await ApiManager.getTenderById(params.id);
    if (res?.status === 200 && res?.data?.result) {
      const { files, ...data } = res.data.result;
      if (Array.isArray(files)) {
        setOldFiles(files);
      }
      setTenderData({
        tenderTitle: data?.tenderTitle,
        refNo: data?.refNo,
        publicationDate: data?.publicationDate,
        publicationTime: data?.publicationTime,
        publicationTimeZone: data?.publicationTimeZone,
        submissionDate: data?.submissionDate,
        submissionTime: data?.submissionTime,
        submissionTimeZone: data?.submissionTimeZone,
        beneficiatyLocation: data?.beneficiatyLocation,
        lng: data?.lng || '',
        lat: data?.lat || '',
        procurementCode: data?.procurementCode,
        procedureType: data?.procedureType,
        unspsCode: data?.unspsCode,
        introduction: data?.introduction,
        files: [],
        submissionInstructions: data?.submissionInstructions,
        deadlineForQueries: data?.deadlineForQueries,
        userKey1: data?.userKey1,
        userKey2: data?.userKey2,
        userKey3: data?.userKey3,
      });
    }
    setLoading(false);
  };

  const deleteTenderFile = async (path = '') => {
    const res = await ApiManager.deleteTenderFile(params.id, path);

    if (res?.status === 200) {
      setOldFiles(oldFiles.filter((item) => item != path));
    }
    setLoading(false);
  };

  const getOrganizationUser = async () => {
    const res = await ApiManager.getOrganizationUser();
    if (res?.status === 200 && res?.data?.result) {
      const data = res.data.result;

      setCommitteeMembers(data || []);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (params.id) {
      getTenderById();
    } else {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    getOrganizationUser();
  }, []);

  const addTender = async () => {
    const data = new FormData();
    data.append('tenderTitle', tenderData.tenderTitle);
    data.append('refNo', tenderData.refNo);
    data.append('publicationDate', tenderData.publicationDate);
    data.append('publicationTime', tenderData.publicationTime);
    data.append('publicationTimeZone', tenderData.publicationTimeZone);
    data.append('submissionDate', tenderData.submissionDate);
    data.append('submissionTime', tenderData.submissionTime);
    data.append('submissionTimeZone', tenderData.submissionTimeZone);
    data.append('beneficiatyLocation', tenderData.beneficiatyLocation);
    data.append('lat', tenderData.lat);
    data.append('lng', tenderData.lng);
    data.append('procurementCode', tenderData.procurementCode);
    data.append('procedureType', tenderData.procedureType);
    data.append('unspsCode', tenderData.unspsCode);
    data.append('introduction', tenderData.introduction);
    data.append('submissionInstructions', tenderData.submissionInstructions);
    data.append('deadlineForQueries', tenderData.deadlineForQueries);
    data.append('userKey1', tenderData?.userKey1 || '');
    data.append('userKey2', tenderData?.userKey2 || '');
    data.append('userKey3', tenderData?.userKey3 || '');
    tenderData.files.map((item, index) => {
      data.append(`files`, item);
    });
    if (params.id) {
      const res = await ApiManager.editTender(params.id, data);
      if (res?.status === 200) {
        successNonification('Tender updated');
        navigate(routesName.tenderListing);
      } else {
        errorNonification(res?.data?.message || 'Something went wrong');
      }
    } else {
      const res = await ApiManager.addTender(data);
      if (res?.status === 200) {
        successNonification('Tender added');
        navigate(routesName.tenderListing);
      } else {
        errorNonification(res?.data?.message || 'Something went wrong');
      }
    }
  };

  const breadcrumbs = [
    { title: 'Dashboard', path: routesName.dashboard },
    { title: 'All Tenders', path: routesName.tenderListing },
    { title: params?.id ? 'Updating Tender' : 'Add New Tender' },
  ];

  return (
    <div>
      <div className="mb-6">
        <BreadcrumbsWrapper breadcrumbs={breadcrumbs} />
      </div>
      <div className="text-2xl">
        {params?.id ? 'Updating' : 'Adding new'} tender
      </div>

      <div className="mt-12 mx-auto">
        <div className="flex lg:flex-row flex-col gap-4">
          <div>
            <Tabs
              orientation={width > 1024 ? 'vertical' : 'horizontal'}
              variant="scrollable"
              value={activeTab}
              onChange={(e, value) => setActiveTab(value)}
              aria-label="Vertical tabs example"
              sx={{ borderRight: 1, borderColor: 'divider' }}
            >
              <Tab
                label="Project Information"
                {...a11yProps(0)}
                disabled={activeTab !== 0}
              />
              <Tab
                label="Description"
                {...a11yProps(1)}
                disabled={activeTab !== 1}
              />
              <Tab
                label="Upload Files"
                {...a11yProps(2)}
                disabled={activeTab !== 2}
              />
              <Tab
                label="Instructions"
                {...a11yProps(3)}
                disabled={activeTab !== 3}
              />
              <Tab
                label="Opening committee"
                {...a11yProps(4)}
                disabled={activeTab !== 4}
              />
              <Tab
                label="Submission"
                {...a11yProps(5)}
                disabled={activeTab !== 5}
              />
            </Tabs>
          </div>
          {!loading && (
            <div className="flex-1 px-4">
              <TabPanel value={activeTab} index={0}>
                <Formik
                  initialValues={{
                    tenderTitle: tenderData.tenderTitle,
                    refNo: tenderData.refNo,
                    publicationDate: tenderData?.publicationDate
                      ? moment(tenderData.publicationDate).format('YYYY-MM-DD')
                      : '',
                    publicationTime: tenderData.publicationTime,
                    publicationTimeZone: tenderData.publicationTimeZone,
                    submissionDate: tenderData?.submissionDate
                      ? moment(tenderData.submissionDate).format('YYYY-MM-DD')
                      : '',
                    submissionTime: tenderData.submissionTime,
                    submissionTimeZone: tenderData.submissionTimeZone,
                    beneficiatyLocation: tenderData.beneficiatyLocation,
                    procurementCode: tenderData.procurementCode,
                    procedureType: tenderData.procedureType,
                    unspsCode: tenderData.unspsCode,
                    lng: tenderData.lng,
                    lat: tenderData.lat,
                  }}
                  validationSchema={yup.object().shape({
                    tenderTitle: validationSchema.required('Tender Title'),
                    refNo: validationSchema.required('Ref No'),
                    publicationDate: params?.id
                      ? validationSchema.dateRequired('Publication Date')
                      : validationSchema.publicationDate('Publication Date'),
                    publicationTime:
                      validationSchema.required('Publication Time'),
                    publicationTimeZone: validationSchema.required(
                      'Publication Time Zone'
                    ),
                    submissionDate: validationSchema.submissionDate(
                      'Submission Date',
                      'Publication Date'
                    ),
                    submissionTime:
                      validationSchema.required('Submission Time'),
                    submissionTimeZone: validationSchema.required(
                      'Submission Time Zone'
                    ),
                    beneficiatyLocation: validationSchema.required(
                      'Beneficiaty Location'
                    ),
                    procurementCode:
                      validationSchema.required('Procurement Code'),
                    procedureType: validationSchema.required('Procedure Type'),
                    unspsCode: validationSchema.required('UNSpSC Code'),
                  })}
                  onSubmit={(values, actions) => {
                    try {
                      setTenderData({ ...tenderData, ...values });
                      setActiveTab((tab) => tab + 1);
                    } catch (error) {}
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    setFieldTouched,
                  }) => (
                    <Grid container spacing={2}>
                      <Grid item sm={8} xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            Title of Tender{' '}
                            <span className="text-red-500">*</span>
                          </label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            name="tenderTitle"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.tenderTitle}
                            helperText={
                              touched.tenderTitle && errors.tenderTitle
                            }
                            error={
                              !!touched.tenderTitle && !!errors.tenderTitle
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item sm={4} xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            Ref No <span className="text-red-500">*</span>
                          </label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            name="refNo"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.refNo}
                            helperText={touched.refNo && errors.refNo}
                            error={!!touched.refNo && !!errors.refNo}
                          />
                        </div>
                      </Grid>
                      <Grid item sm={3.5} xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            Publication Date{' '}
                            <span className="text-red-500">*</span>
                          </label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            type="date"
                            name="publicationDate"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.publicationDate}
                            helperText={
                              touched.publicationDate && errors.publicationDate
                            }
                            error={
                              !!touched.publicationDate &&
                              !!errors.publicationDate
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item sm={3.5} xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            Time <span className="text-red-500">*</span>
                          </label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            type="time"
                            name="publicationTime"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.publicationTime}
                            helperText={
                              touched.publicationTime && errors.publicationTime
                            }
                            error={
                              !!touched.publicationTime &&
                              !!errors.publicationTime
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item sm={5} xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            Time Zone <span className="text-red-500">*</span>
                          </label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            name="publicationTimeZone"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.publicationTimeZone}
                            helperText={
                              touched.publicationTimeZone &&
                              errors.publicationTimeZone
                            }
                            error={
                              !!touched.publicationTimeZone &&
                              !!errors.publicationTimeZone
                            }
                            select
                          >
                            <MenuItem value="">
                              <i className="text-gray-500">Select</i>
                            </MenuItem>
                            {timeZoneArray.map((item, index) => (
                              <MenuItem value={item.value} key={index}>
                                {item.label}
                              </MenuItem>
                            ))}
                          </TextFieldWrapper>
                        </div>
                      </Grid>
                      <Grid item sm={3.5} xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            Submission Deadline{' '}
                            <span className="text-red-500">*</span>
                          </label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            type="date"
                            name="submissionDate"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.submissionDate}
                            helperText={
                              touched.submissionDate && errors.submissionDate
                            }
                            error={
                              !!touched.submissionDate &&
                              !!errors.submissionDate
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item sm={3.5} xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            Time <span className="text-red-500">*</span>
                          </label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            type="time"
                            name="submissionTime"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.submissionTime}
                            helperText={
                              touched.submissionTime && errors.submissionTime
                            }
                            error={
                              !!touched.submissionTime &&
                              !!errors.submissionTime
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item sm={5} xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            Time Zone <span className="text-red-500">*</span>
                          </label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            name="submissionTimeZone"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.submissionTimeZone}
                            helperText={
                              touched.submissionTimeZone &&
                              errors.submissionTimeZone
                            }
                            error={
                              !!touched.submissionTimeZone &&
                              !!errors.submissionTimeZone
                            }
                            select
                          >
                            <MenuItem value="">
                              <i className="text-gray-500">Select</i>
                            </MenuItem>
                            {timeZoneArray.map((item, index) => (
                              <MenuItem value={item.value} key={index}>
                                {item.label}
                              </MenuItem>
                            ))}
                          </TextFieldWrapper>
                        </div>
                      </Grid>

                      <Grid item sm={6} xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            Beneficiary Geographical Location{' '}
                            <span className="text-red-500">*</span>
                          </label>
                          <PlacesAutofcompleteWrapper
                            onInput={(value) => {}}
                            placeholder="Search by Region or country"
                            value={values.beneficiatyLocation}
                            name="beneficiatyLocation"
                            onChange={(address, lngLat) => {
                              setFieldValue('beneficiatyLocation', address);
                              setFieldValue('lat', lngLat?.lat);
                              setFieldValue('lng', lngLat?.lng);
                            }}
                            onBlur={() => {
                              setFieldTouched('beneficiatyLocation');
                            }}
                            fullWidth
                            helperText={
                              touched.beneficiatyLocation &&
                              errors.beneficiatyLocation
                            }
                            error={
                              !!touched.beneficiatyLocation &&
                              !!errors.beneficiatyLocation
                            }
                          />
                        </div>
                      </Grid>

                      <Grid item sm={6} xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            Procurement Code{' '}
                            <span className="text-red-500">*</span>
                          </label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            name="procurementCode"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.procurementCode}
                            helperText={
                              touched.procurementCode && errors.procurementCode
                            }
                            error={
                              !!touched.procurementCode &&
                              !!errors.procurementCode
                            }
                            select
                          >
                            <MenuItem value="">
                              <i className="text-gray-500">Select</i>
                            </MenuItem>
                            {procurementCodeArray.map((item, index) => (
                              <MenuItem value={item} key={index}>
                                {item}
                              </MenuItem>
                            ))}
                          </TextFieldWrapper>
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            UNSPSC Codes <span className="text-red-500">*</span>
                          </label>
                          <TextFieldWrapper
                            placeholder="Codes"
                            name="unspsCode"
                            onBlur={handleBlur}
                            value={values.unspsCode}
                            helperText={touched.unspsCode && errors.unspsCode}
                            error={!!touched.unspsCode && !!errors.unspsCode}
                            onClick={openUNSPSPopup}
                            aria-describedby={id}
                            InputProps={{
                              endAdornment: (
                                <IconButton
                                  onClick={openUNSPSPopup}
                                  aria-describedby={id}
                                >
                                  <KeyboardArrowDown fontSize="small" />
                                </IconButton>
                              ),
                            }}
                          />

                          <Popover
                            id={id}
                            open={isOpenUNSPSPopup}
                            anchorEl={anchorEl}
                            onClose={closeUNSPSPopup}
                            /*  anchorOrigin={{
                                  vertical: 'bottom',
                                  horizontal: 'left',
                                }} */
                          >
                            <UNSPSCodesSelect
                              value={values.unspsCode}
                              onItemClick={(item) => {
                                setFieldValue('unspsCode', item.Title);
                                closeUNSPSPopup();
                              }}
                            />
                          </Popover>
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            Procedure Type{' '}
                            <span className="text-red-500">*</span>
                          </label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            name="procedureType"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.procedureType}
                            helperText={
                              touched.procedureType && errors.procedureType
                            }
                            error={
                              !!touched.procedureType && !!errors.procedureType
                            }
                            select
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            <MenuItem value={'Request for Quotion (RFQ)'}>
                              Request for Quotion (RFQ)
                            </MenuItem>
                            <ListSubheader>
                              Open Procedure (1 envelope)
                            </ListSubheader>
                            <MenuItem value={'Invitation to Bid (ITB)'}>
                              <span className="ml-6">
                                Invitation to Bid (ITB)
                              </span>
                            </MenuItem>
                            <ListSubheader>
                              Open Procedure (2 envelope)
                            </ListSubheader>
                            <MenuItem
                              value={'Pre-Qualification of Suppliers (PQS)'}
                            >
                              <span className="ml-6">
                                Pre-Qualification of Suppliers (PQS)
                              </span>
                            </MenuItem>
                            <MenuItem value={'Request for Information (RFI)'}>
                              <span className="ml-6">
                                Request for Information (RFI)
                              </span>
                            </MenuItem>
                            <MenuItem value={'Request for Porposol (RFP)'}>
                              <span className="ml-6">
                                Request for Porposol (RFP)
                              </span>
                            </MenuItem>
                            <MenuItem value={'Expression of Interest (EOI)'}>
                              <span className="ml-6">
                                Expression of Interest (EOI)
                              </span>
                            </MenuItem>
                            <MenuItem value={'Consultancy (IC)'}>
                              <span className="ml-6">Consultancy (IC)</span>
                            </MenuItem>
                          </TextFieldWrapper>
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="flex items-center justify-end mt-8">
                          <LightBlueButton
                            onClick={handleSubmit}
                            className="text-xs bg-main text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                          >
                            Next
                          </LightBlueButton>
                        </div>
                      </Grid>
                    </Grid>
                  )}
                </Formik>
              </TabPanel>
              <TabPanel value={activeTab} index={1}>
                <Formik
                  initialValues={{
                    introduction: tenderData.introduction,
                  }}
                  validationSchema={yup.object().shape({
                    introduction: validationSchema.required('Introduction'),
                  })}
                  onSubmit={(values, actions) => {
                    try {
                      setTenderData({ ...tenderData, ...values });
                      setActiveTab((tab) => tab + 1);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                  }) => (
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            Introduction <span className="text-red-500">*</span>
                          </label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            multiline
                            minRows={5}
                            name="introduction"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.introduction}
                            helperText={
                              touched.introduction && errors.introduction
                            }
                            error={
                              !!touched.introduction && !!errors.introduction
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="flex items-center justify-between mt-8">
                          <LightGrayButton
                            onClick={() => {
                              setActiveTab((tab) => tab - 1);
                            }}
                            className="text-xs border border-1 border-[var(--blue)] text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                          >
                            Back
                          </LightGrayButton>

                          <LightBlueButton
                            onClick={handleSubmit}
                            className="text-xs bg-main text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                          >
                            Next
                          </LightBlueButton>
                        </div>
                      </Grid>
                    </Grid>
                  )}
                </Formik>
              </TabPanel>
              <TabPanel value={activeTab} index={2}>
                <Formik
                  initialValues={{
                    files: tenderData.files,
                  }}
                  /*  validationSchema={yup.object().shape({
                      files: validationSchema.required('files'),
                    })} */
                  onSubmit={(values, actions) => {
                    try {
                      setTenderData({ ...tenderData, ...values });
                      setActiveTab((tab) => tab + 1);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                  }) => (
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <div className="flex items-center gap-2">
                          <div className="flex">
                            <label
                              className="bg-green-500 px-6 py-2 text-center"
                              htmlFor="files"
                            >
                              Upload Files
                            </label>
                          </div>
                          <input
                            placeholder="Placeholder"
                            hidden
                            type="file"
                            id="files"
                            multiple
                            name="files"
                            onChange={(e) => {
                              var files = [...values.files];
                              if (e.target.files && e.target.files.length > 0) {
                                for (
                                  var i = 0;
                                  i < e.target.files.length;
                                  i++
                                ) {
                                  files.push(e.target.files[i]);
                                }
                              }
                              setFieldValue('files', files);
                            }}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="flex flex-col gap-2">
                          {Array.isArray(oldFiles) &&
                            oldFiles.map((item, index) => {
                              return (
                                <div
                                  key={index + item}
                                  className="flex gap-2 items-center"
                                >
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      deleteTenderFile(item);
                                    }}
                                  >
                                    <Delete size="small" />
                                  </IconButton>
                                  <span className="text-[var(--dark-blue)]">
                                    {toAbsolutePath(item)}
                                  </span>
                                </div>
                              );
                            })}
                          {values.files.map((item, index) => {
                            return (
                              <div
                                key={index + item.name}
                                className="flex gap-2 items-center"
                              >
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    var files = values.files;
                                    files.splice(index, 1);
                                    setFieldValue('files', files);
                                  }}
                                >
                                  <Delete size="small" />
                                </IconButton>
                                <span>{item.name}</span>
                              </div>
                            );
                          })}
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="flex items-center justify-between mt-8">
                          <LightGrayButton
                            onClick={() => {
                              setActiveTab((tab) => tab - 1);
                            }}
                            className="text-xs border border-1 border-[var(--blue)] text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                          >
                            Back
                          </LightGrayButton>

                          <LightBlueButton
                            onClick={handleSubmit}
                            className="text-xs bg-main text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                          >
                            Next
                          </LightBlueButton>
                        </div>
                      </Grid>
                    </Grid>
                  )}
                </Formik>
              </TabPanel>
              <TabPanel value={activeTab} index={3}>
                <Formik
                  initialValues={{
                    submissionInstructions: tenderData.submissionInstructions,
                    deadlineForQueries: tenderData?.deadlineForQueries
                      ? moment(tenderData.deadlineForQueries).format(
                          'YYYY-MM-DD'
                        )
                      : '',
                    publicationDate: moment(tenderData.publicationDate).format(
                      'YYYY-MM-DD'
                    ),
                    submissionDate: moment(tenderData.submissionDate).format(
                      'YYYY-MM-DD'
                    ),
                  }}
                  validationSchema={yup.object().shape({
                    submissionInstructions: validationSchema.required(
                      'Submission Instructions'
                    ),
                    deadlineForQueries: params?.id
                      ? validationSchema.dateRequired('Deadline for quries')
                      : validationSchema.deadlineForQueries,
                    publicationDate: params?.id
                      ? validationSchema.dateRequired('Deadline for quries')
                      : validationSchema.publicationDate(),
                    submissionDate: params?.id
                      ? validationSchema.dateRequired('Deadline for quries')
                      : validationSchema.submissionDate(),
                  })}
                  onSubmit={(values, actions) => {
                    try {
                      setTenderData({ ...tenderData, ...values });
                      setActiveTab((tab) => tab + 1);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                  }) => (
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            Submission Instructions{' '}
                            <span className="text-red-500">*</span>
                          </label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            multiline
                            minRows={5}
                            name="submissionInstructions"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.submissionInstructions}
                            helperText={
                              touched.submissionInstructions &&
                              errors.submissionInstructions
                            }
                            error={
                              !!touched.submissionInstructions &&
                              !!errors.submissionInstructions
                            }
                          />
                        </div>
                      </Grid>

                      <Grid item md={6} xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            Deadline for quries{' '}
                            <span className="text-red-500">*</span>
                          </label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            type="date"
                            name="deadlineForQueries"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.deadlineForQueries}
                            helperText={
                              touched.deadlineForQueries &&
                              errors.deadlineForQueries
                            }
                            error={
                              !!touched.deadlineForQueries &&
                              !!errors.deadlineForQueries
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="flex items-center justify-between mt-8">
                          <LightGrayButton
                            onClick={() => {
                              setActiveTab((tab) => tab - 1);
                            }}
                            className="text-xs border border-1 border-[var(--blue)] text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                          >
                            Back
                          </LightGrayButton>

                          <LightBlueButton
                            onClick={handleSubmit}
                            className="text-xs bg-main text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                          >
                            Next
                          </LightBlueButton>
                        </div>
                      </Grid>
                    </Grid>
                  )}
                </Formik>
              </TabPanel>
              <TabPanel value={activeTab} index={4}>
                <Formik
                  initialValues={{
                    userKey1: tenderData?.userKey1 || '',
                    userKey2: tenderData?.userKey2 || '',
                    userKey3: tenderData?.userKey3 || '',
                  }}
                  validationSchema={yup.object().shape({
                    userKey1: validationSchema.required('userKey1'),
                    /* userKey2: validationSchema.required('userKey2'),
                      userKey3: validationSchema.required('userKey3'), */
                  })}
                  onSubmit={(values, actions) => {
                    try {
                      setTenderData({ ...tenderData, ...values });
                      setActiveTab((tab) => tab + 1);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                  }) => (
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <div className=" ">
                          Select & invite opening committee members
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">
                            User/Key 1 <span className="text-red-500">*</span>
                          </label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            name="userKey1"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.userKey1}
                            helperText={touched.userKey1 && errors.userKey1}
                            error={!!touched.userKey1 && !!errors.userKey1}
                            select
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            {Array.isArray(committeeMembers) &&
                              committeeMembers
                                .filter(
                                  (item) =>
                                    item._id !== values.userKey2 &&
                                    item._id !== values.userKey3
                                )
                                .map((item, index) => (
                                  <MenuItem value={item._id}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                          </TextFieldWrapper>
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">User/Key 2</label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            name="userKey2"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.userKey2}
                            helperText={touched.userKey2 && errors.userKey2}
                            error={!!touched.userKey2 && !!errors.userKey2}
                            select
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            {Array.isArray(committeeMembers) &&
                              committeeMembers
                                .filter(
                                  (item) =>
                                    item._id !== values.userKey3 &&
                                    item._id !== values.userKey1
                                )
                                .map((item, index) => (
                                  <MenuItem value={item._id}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                          </TextFieldWrapper>
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="flex flex-col gap-2">
                          <label className="text-xs">User/Key 3</label>
                          <TextFieldWrapper
                            placeholder="Placeholder"
                            name="userKey3"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.userKey3}
                            helperText={touched.userKey3 && errors.userKey3}
                            error={!!touched.userKey3 && !!errors.userKey3}
                            select
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            {Array.isArray(committeeMembers) &&
                              committeeMembers
                                .filter(
                                  (item) =>
                                    item._id !== values.userKey2 &&
                                    item._id !== values.userKey1
                                )
                                .map((item, index) => (
                                  <MenuItem value={item._id}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                          </TextFieldWrapper>
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="flex items-center justify-between">
                          <DarkBlueButton
                            onClick={toggleAddUser}
                            className="text-sm bg-[var(--yellow)] text-center px-6 py-2 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                          >
                            Add committee member
                          </DarkBlueButton>
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className="flex items-center justify-between mt-8">
                          <LightGrayButton
                            onClick={() => {
                              setActiveTab((tab) => tab - 1);
                            }}
                            className="text-xs border border-1 border-[var(--blue)] text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                          >
                            Back
                          </LightGrayButton>

                          <LightBlueButton
                            onClick={handleSubmit}
                            className="text-xs bg-main text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                          >
                            Next
                          </LightBlueButton>
                        </div>
                      </Grid>
                      <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        open={isAddingUser}
                        onClose={toggleAddUser}
                        closeAfterTransition
                        slots={{ backdrop: Backdrop }}
                        slotProps={{
                          backdrop: {
                            timeout: 500,
                          },
                        }}
                      >
                        <Fade in={isAddingUser}>
                          <Box
                            sx={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              maxWidth: 500,
                              transform: 'translate(-50%, -50%)',
                              bgcolor: 'background.paper',
                              border: '2px solid #000',
                              boxShadow: 24,
                              p: 3,
                            }}
                          >
                            <AddCommiteMember
                              onSuccess={() => {
                                getOrganizationUser();
                                toggleAddUser();
                              }}
                            />
                          </Box>
                        </Fade>
                      </Modal>
                    </Grid>
                  )}
                </Formik>
              </TabPanel>
              <TabPanel value={activeTab} index={5}>
                <div>
                  <div className="flex flex-col gap-2">
                    <Grid container spacing={2}>
                      <Grid item xs={12} className="flex gap-2">
                        <span className="font-bold">Title of Tender:</span>
                        <span>{tenderData?.tenderTitle}</span>
                      </Grid>
                      <Grid item xs={12} className="flex gap-2">
                        <span className="font-bold">Ref No: </span>
                        <span>{tenderData?.refNo}</span>
                      </Grid>
                      <Grid item xs={12} className="flex gap-2">
                        <span className="font-bold">Publication Date:</span>
                        <span>
                          {moment(tenderData?.publicationDate).format(
                            'DD-MM-YYYY'
                          )}
                        </span>
                      </Grid>
                      <Grid item xs={12} className="flex gap-2">
                        <span className="font-bold">Time:</span>
                        <span>
                          {moment(tenderData?.publicationTime).format(
                            'DD-MM-YYYY'
                          )}
                        </span>
                      </Grid>
                      <Grid item xs={12} className="flex gap-2">
                        <span className="font-bold"> Time Zone:</span>
                        <span>{tenderData?.publicationTimeZone}</span>
                      </Grid>
                      <Grid item xs={12} className="flex gap-2">
                        <span className="font-bold">Submission Deadline:</span>
                        <span>{tenderData?.submissionDate}</span>
                      </Grid>
                      <Grid item xs={12} className="flex gap-2">
                        <span className="font-bold">Time:</span>
                        <span>{tenderData?.submissionTime}</span>
                      </Grid>
                      <Grid item xs={12} className="flex gap-2">
                        <span className="font-bold">Time Zone:</span>
                        <span>{tenderData?.submissionTimeZone}</span>
                      </Grid>
                      <Grid item xs={12} className="flex gap-2">
                        <span className="font-bold">
                          Beneficiary Geographical Location:{' '}
                        </span>

                        <span>{tenderData?.beneficiatyLocation}</span>
                      </Grid>
                      <Grid item xs={12} className="flex gap-2">
                        <span className="font-bold">Procurement Code :</span>
                        <span>{tenderData?.procurementCode}</span>
                      </Grid>
                      <Grid item xs={12} className="flex gap-2">
                        <span className="font-bold">Procedure Type: </span>
                        <span>{tenderData?.procedureType}</span>
                      </Grid>
                      <Grid item xs={12} className="flex gap-2">
                        <span className="font-bold">Introduction:</span>
                        <span>{tenderData?.introduction}</span>
                      </Grid>
                      <Grid item xs={12} className="flex gap-2">
                        <span className="font-bold">
                          Submission Instructions:
                        </span>
                        <span>{tenderData?.submissionInstructions}</span>
                      </Grid>
                      <Grid item xs={12} className="flex gap-2">
                        <span className="font-bold">Deadline for quries:</span>
                        <span>
                          {moment(tenderData?.deadlineForQueries).format(
                            'DD-MM-YYYY'
                          )}
                        </span>
                      </Grid>
                      {tenderData?.userKey1 && (
                        <Grid item xs={12} className="flex gap-2">
                          <span className="font-bold">User/Key 1:</span>

                          {Array.isArray(committeeMembers) &&
                            committeeMembers
                              .filter(
                                (item) => item._id === tenderData.userKey1
                              )
                              .map((item, index) => (
                                <span key={index}>{item.name}</span>
                              ))}
                        </Grid>
                      )}
                      {tenderData?.userKey2 && (
                        <Grid item xs={12} className="flex gap-2">
                          <span className="font-bold">User/Key 2:</span>

                          {Array.isArray(committeeMembers) &&
                            committeeMembers
                              .filter(
                                (item) => item._id === tenderData.userKey2
                              )
                              .map((item, index) => (
                                <span key={index}>{item.name}</span>
                              ))}
                        </Grid>
                      )}
                      {tenderData?.userKey3 && (
                        <Grid item xs={12} className="flex gap-2">
                          <span className="font-bold"> User/Key 3:</span>

                          {Array.isArray(committeeMembers) &&
                            committeeMembers
                              .filter(
                                (item) => item._id === tenderData.userKey3
                              )
                              .map((item, index) => (
                                <span key={index}>{item.name}</span>
                              ))}
                        </Grid>
                      )}
                      {Array.isArray(oldFiles) &&
                        oldFiles.map((item, index) => {
                          return (
                            <Grid
                              item
                              key={index}
                              xs={12}
                              className="flex gap-2"
                            >
                              <span className="font-bold">
                                File {index + 1} :
                              </span>
                              <a href={toAbsolutePath(item)} target="_blank">
                                {toAbsolutePath(item)}
                              </a>
                            </Grid>
                          );
                        })}
                      {Array.isArray(tenderData.files) &&
                        tenderData.files.map((item, index) => (
                          <Grid item key={index} xs={12} className="flex gap-2">
                            <span className="font-bold">
                              File{' '}
                              {Array.isArray(oldFiles)
                                ? oldFiles.length + index + 1
                                : index + 1}
                            </span>
                            <span> {item.name}</span>
                          </Grid>
                        ))}
                    </Grid>
                  </div>
                  <div className="flex items-center justify-between mt-8">
                    <LightGrayButton
                      onClick={() => {
                        setActiveTab((tab) => tab - 1);
                      }}
                      className="text-xs border border-1 border-[var(--blue)] text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                    >
                      Back
                    </LightGrayButton>
                    <LightBlueButton
                      onClick={addTender}
                      className="text-xs bg-main text-center px-4 py-1 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                    >
                      Submit
                    </LightBlueButton>
                  </div>
                </div>
              </TabPanel>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Component;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <h1>{children}</h1>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const UNSPSCodesSelect = ({ onItemClick = () => {}, value = '' }) => {
  const [tree, setTree] = useState('');

  useEffect(() => {
    loadCodes();
  }, []);

  const loadCodes = () => {
    const data = UNSPSCodes.map((item) => generateTree(item));
    setTree(data);
  };

  const generateTree = (item) => {
    if (item.child) {
      return (
        <TreeItem key={item.Id} itemId={`${item.Id}`} label={item.Title}>
          {item.child.map((_item) => generateTree(_item))}
        </TreeItem>
      );
    }
    return (
      <TreeItem
        className={`${value === item.Title ? 'bg-red-200' : ''}`}
        onClick={() => onItemClick(item)}
        key={item.Id}
        itemId={`${item.Id}`}
        label={item.Title}
      />
    );
  };

  return <SimpleTreeView>{tree}</SimpleTreeView>;
};
